module.exports = "<listado-general \r\n  [listado]=\"subscriptions\" \r\n  [titulo]=\"'SISTEMAS' | translate\"\r\n  [urladicional]=\"''\"\r\n  [clickBack]=\"true\"\r\n  [ocultarNuevo]=\"ocultarNuevo\"\r\n  (clickNuevo)=\"navegarNuevaSubscription()\"\r\n  [leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | translate\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/listado.subscriptions.component.html
// module id = ../../../../../src/app/private/channels/listado.subscriptions.component.html
// module chunks = main